import { CMS_DETAILS } from 'modules/cmsDetails/actionTypes';

const getCmsDetailsData = () => (dispatch, getState, { api }) => {
  dispatch({
    type: CMS_DETAILS.CMS_DETAILS_REQUEST,
    payload: {},
    test: api
      .post(`detailCMS.json`)
      .then(res => {
        dispatch({
          type: CMS_DETAILS.CMS_DETAILS_SUCCESS,
          payload: res.data,
        });
        return res.data;
      })
      .catch(error => {
        dispatch({
          type: CMS_DETAILS.CMS_DETAILS_FAILURE,
          error,
        });
      }),
  });
};

export const CmsDetailsActions = {
  getCmsDetailsData,
};
